import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="assembly-show-all"
export default class extends Controller {
  connect() {
    if (!window.location.hash) return

    this.element.classList.remove("hidden")
  }
}
